import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ActivatedRoute, Router } from '@angular/router';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';
import { environment } from 'src/environments/environment';
import { PromotionService } from '../../services/promotion.service';
import { ProductService } from 'src/app/product/services/product.service';
import { AlertService } from 'src/app/core/services/alert.service';
import { CartService } from 'src/app/cart/services/cart.service';
import { HomeService } from 'src/app/home/services/home.service';
import { ToastrService } from 'ngx-toastr';
import { SharedConsts } from 'src/app/shared/constants';
import { SharedService } from 'src/app/shared/services/shared.service';

@Component({
    selector: 'app-product-listing',
    templateUrl: './product-listing.component.html',
    styleUrls: ['./product-listing.component.scss'],
    standalone: false
})
export class ProductListingComponent implements OnInit {
  x = 5;
  componentLoaded = false;
  promotionApplyCount = 0;
  itemsPending:any=0;
  popupMessage = '';
  isReadonly = true;
  commonBottonText: any = 'Ok';
  bsModalRef: BsModalRef;
  rule_id:any;
  productListing:any = [];
  freeProductListing:any = [];
  promotionDetails: any= {};
  miniCartDetails: any;
  imagePath = environment.s3_path + '/' + environment.product_image_folder + '/';
  global_data : any = {};
  product_for_24_hr:any = {};
  totalCost:any=0
  totalRSP:any=0
  constructor(private activatedRoute: ActivatedRoute, private promotionService: PromotionService,
    private statePersist: StatePersistService, private statePersiste: StatePersistService,
    private googleAnalyticsService: GoogleAnalyticsService, private productService: ProductService,
    private modalService: BsModalService, private alertService: AlertService,
    private cartService: CartService, private homeService: HomeService,
    private toastService: ToastrService, private router: Router, private sharedService: SharedService) { }

  ngOnInit(): void {
    this.rule_id = this.activatedRoute.snapshot.paramMap.get('promotionid')
    this.global_data = this.statePersist.getLocalStorage('global_data')
    this.statePersist.watchGlobalDataStorage().subscribe(() => {
      this.global_data = this.statePersist.getLocalStorage('global_data')
    })
    this.promotionProductListing()
    this.statePersist.watchPromotionProductsStorage().subscribe(() => {
      this.promotionProductListing()
    })
    
    this.miniCartDetails = this.statePersiste.getLocalStorage('mini_cart_details')
    this.statePersiste.watchMiniCartDetailChange().subscribe(() => {
      this.miniCartDetails = this.statePersiste.getLocalStorage('mini_cart_details')
    })
  }

  promotionProductListing(){
    this.componentLoaded = false;
    this.promotionService.productsOfPromotion({'rule_id':this.rule_id})
      .subscribe(
        data => {
          if (data.response) {
            if (data.status == 1190) {
              this.toastService.error(data.response)
              this.router.navigate(['promotion/All'])
            }
            else if (data.status == 2212){
              this.alertService.error(data.response)
            }
            else if (data.status == 1161){
              this.alertService.error(data.response)
              this.router.navigate(['promotion/All'])
            }
            else{
              this.productListing = data.response.products_paid
              this.productListing?.map(x =>{
                if(x.qty != '' && +x.qty != 0 && x.back_in_stock != '0'){
                  x.showMsg = true
                }
                if(this.global_data?.vat_exempt == 1){
                  x.margin = this.sharedService.getStoreVatFreeMargin(x)
                }
              })
              this.freeProductListing = data.response.products_free
              this.calculateCostAndRSP()
             
              this.promotionDetails = data.response.promotion_details
              this.promotionApplyCount = this.promotionDetails?.in_cart_total_count
              this.itemsPending = this.promotionDetails?.promotion_apply_total_count - this.promotionApplyCount
            }
            this.componentLoaded = true;

          }
        }
      );
  }

  popup(template: TemplateRef<any>){
    this.bsModalRef = this.modalService.show(template,  Object.assign({}, { class: 'modal-dialog-centered custom-modal confirm' }));
  }

  toInteger(value) {
    return parseInt(value)
  }

  addToCart(product, qyt, template: any, type: any, template2:any,popup_24hr_template:any,check_last_order=true) {
    this.googleAnalyticsService.eventEmitter(SharedConsts.PROMOTION_PRODUCT_LISTING_ADDTOCART_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.PROMOTION_PRODUCT_LISTING_ADDTOCART_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
    let dataObj;
    if (product.qty == '') {
      qyt = '1'
    }

    if (!check_last_order){
      this.bsModalRef.hide();
    }

    this.miniCartDetails = this.statePersiste.getLocalStorage('mini_cart_details')
    if (this.miniCartDetails){
      if (this.miniCartDetails.items_count != '0' && this.miniCartDetails.items_count != ''){
        check_last_order = false
      }
    }

    dataObj = {
      "cart_item": {
        "sku": product.sku,
        "qty": qyt,
        "rule_id":this.rule_id,
        "from":"promotion",
        "promotion_applied_count" : +this.promotionDetails?.promotion_applied_count 
      },
      "check_last_order":check_last_order,
    }
    this.productService.addToCart(dataObj)
      .subscribe(
        data => {
          if (data.response) {
            this.popupMessage = ''
            if (data.status == 2212) {
              for (let i = 0; i < this.productListing.length; i++) {
                if (this.productListing[i]['product_id'] == product.product_id) {
                  this.productListing[i]['qty'] = '1'
                }

            }
              this.alertService.error(data.response.msg)
            }
            else if (data.status == 1190) {
              this.toastService.error(data.response)
              this.router.navigate(['promotion/All'])
            }
            else if (data.status == 1161){
              this.alertService.error(data.response)
            }
            else if (data.status == 1169) {
              // product out of stock
              for (let i = 0; i < this.productListing.length; i++) {
                if (this.productListing[i]['product_id'] == product.product_id) {
                  this.productListing[i]['qty'] = '1'
                  this.productListing[i]['back_in_stock'] = '0'
                }
              }
            }
            else if(data.status == 1180){
              localStorage.setItem('closeStorInfoMessage', data.response.msg)
              document.getElementById("openclosedStoreInfo").click();
              for (let i = 0; i < this.productListing.length; i++) {
                if (this.productListing[i]['product_id'] == product.product_id) {
                  this.productListing[i]['qty'] = '1'
                }

            }
            }
            else if (data.status == 1168) {
              for (let i = 0; i < this.productListing.length; i++) {
                if (this.productListing[i]['product_id'] == product.product_id) {
                  this.productListing[i]['qty'] = '1'
                  this.productListing[i]['back_in_stock'] = '0'
                }
              }
              this.popupMessage = data.response
              this.commonBottonText = "Ok, Don't show this again"
              this.popup(template2)
              }
            else if (data.status == 1163) {
              // Product that you are trying to add is not available
              this.alertService.error(data.response)
              this.productListing = this.productListing.filter(item => item.product_id !== product.product_id);

            }
            else if (data.status == 1188) {
              this.product_for_24_hr = product
              this.popupMessage = data.response.split("<br>").join("\n");
              this.commonBottonText = "Confirm"
              this.popup(popup_24hr_template)
            }
            else {
              for (let i = 0; i < this.productListing.length; i++) {
                if (this.productListing[i]['product_id'] == product.product_id) {
                  this.productListing[i]['qty'] = String(qyt)
                  this.productListing[i]['item_id'] = data.response.item_id
                }
              }
              var storeCount
              storeCount = this.statePersiste.getLocalStorage('selectedStoreAddress')
              if (template && storeCount['totalStoreCount'] > 1){
                this.popup(template)
              }
            this.promotionApplyCount = data.response.in_cart_total_count
            if(data.response.in_cart_total_count == 0){
              this.itemsPending = 0
              this.promotionProductListing()
           }else{
             this.itemsPending = this.promotionDetails?.promotion_apply_total_count - this.promotionApplyCount
             this.freeProductListing = []
             this.freeProductListing = data.response.free_product?.free_products
             this.calculateCostAndRSP()
           }
          }
            this.statePersiste.emitminiCartData('min cart update')

          }

        }
      );
  }

  qytChange(product, qyt, template,template2: any, type:any) {
    this.statePersist.amendQtyGoogleanalyticsEvent()
    if (product.item_id !== '') {
      if (qyt == 0){
        for (let i = 0; i < this.productListing.length; i++) {
          if (this.productListing[i]['product_id'] == product.product_id) {
            this.productListing[i]['qty'] = 0
          }
        }
        this.removeItem(product)
      }else{
        this.qytUpdate(product, String(qyt), template)
      }

    }
    else {
      for (let i = 0; i < this.productListing.length; i++) {
        if (this.productListing[i]['product_id'] == product.product_id) {

          this.productListing[i]['qty'] = String(qyt)
        }
      }
    }
  }

  qytUpdate(product, qyt, template) {
    this.productService.qytUpdate({ 
        'item_id': parseInt(product.item_id), 
        'qty': qyt,  
        "rule_id":this.rule_id,
        "from":"promotion",
        "promotion_applied_count" : +this.promotionDetails?.promotion_applied_count 
      })
      .subscribe(
        data => {
          if (data.response) {
            this.popupMessage = ''
            if (data.status == 1190) {
              this.toastService.error(data.response)
              this.router.navigate(['promotion/All'])
            }
            else if (data.status == 1169) {
              for (let i = 0; i < this.productListing.length; i++) {
                if (this.productListing[i]['product_id'] == product.product_id) {
                  this.productListing[i]['qty'] = '1'
                  this.productListing[i]['item_id'] = ''
                  this.productListing[i]['back_in_stock'] = '0'
                }
              }
            }
            
            else if(data.status == 1180){
                localStorage.setItem('closeStorInfoMessage', data.response.msg)
                document.getElementById("openclosedStoreInfo").click();
                for (let i = 0; i < this.productListing.length; i++) {
                  if (this.productListing[i]['product_id'] == product.product_id) {
                    this.productListing[i]['qty'] = data.response.qyt
                  }
              }
              document.getElementById('spiner__btn_'+product.product_id).getElementsByTagName('div')[1].textContent = product.qty

            }
            else if(data.status == 2212){
              this.alertService.error(data.response)
              for (let i = 0; i < this.productListing.length; i++) {
                if (this.productListing[i]['product_id'] == product.product_id) {
                  this.productListing[i]['qty'] = data.response.qty
                }
            }}
            else if (data.status == 2211){
              this.alertService.error(data.response)
              this.promotionProductListing()
            }
            else if (data.status == 1163) {
              this.alertService.error(data.response)
              this.productListing = this.productListing.filter(item => item.product_id !== product.product_id);

            }
            else {
              for (let i = 0; i < this.productListing.length; i++) {
                if (this.productListing[i]['product_id'] == product.product_id) {
                  this.productListing[i]['qty'] = qyt
                }
              }
            this.promotionApplyCount = data.response.in_cart_total_count
            this.promotionDetails.promotion_applied_count = data.response.promotion_applied_count ? data.response.promotion_applied_count : 0 
            this.promotionDetails.is_promotion_applied = data.response.promotion_applied_count > 0 ? 1 : 0
            }
            if(data.response.in_cart_total_count == 0){
               this.itemsPending = 0
               this.promotionProductListing()
            }else{
              this.itemsPending = this.promotionDetails?.promotion_apply_total_count - this.promotionApplyCount
              this.freeProductListing = []
              this.freeProductListing = data.response.free_product?.free_products
              this.calculateCostAndRSP()
            }
            this.statePersiste.emitminiCartData('min cart update')

          }

        }
      );
  }

  addDeal(rule_id){
    var dataObj = {'rule_id':rule_id}
    this.googleAnalyticsService.eventEmitter(SharedConsts.PROMOTION_ADD_DEAL_PROMOTION_DETAILS_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.PROMOTION_ADD_DEAL_PROMOTION_DETAILS_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
    this.homeService.addDeal(dataObj)
      .subscribe(
        data => {

        if(data.status == 1180){
            localStorage.setItem('closeStorInfoMessage', data.response.msg)
            document.getElementById("openclosedStoreInfo").click();
        }
        else if (data.status == 2212){
          this.alertService.error(data.response)
        }
        else if (data.status == 1165) {
          this.toastService.error('Some of the products of the promotion are not available now.')
          this.router.navigate(['promotion/All'])
        }
        else if (data.status == 403 || data.status == 1151 || data.status == 1163){
          this.toastService.error(data.response)
          this.router.navigate(['promotion/All'])
        }
        else{
          this.promotionDetails.is_promotion_applied = 1
          this.promotionDetails.promotion_applied_count = data.response.promotion_applied_count ? data.response.promotion_applied_count : 0 
          this.toastService.success('Deal Applied Sucessfully.')
          this.statePersiste.emitminiCartData('update mini cart')
          this.promotionProductListing()
        }
        }
      );
  }

  removeItem(product){
    let fordata;
    fordata = {
      'item_id': product.item_id,
      "promotion_applied_count" : +this.promotionDetails?.promotion_applied_count 
    }
    this.cartService.removeItem(fordata)
      .subscribe(
        data => {
          if (data.response) {
            if(data.status == 1180){
              localStorage.setItem('closeStorInfoMessage', data.response.msg)
              document.getElementById("openclosedStoreInfo").click();
            }
            else if (data.status == 2212){
              this.alertService.error(data.response)
            }
            else if (data.status == 2211){
              this.alertService.error(data.response)
              this.promotionProductListing()
            }
            else{
              for (let i = 0; i < this.productListing.length; i++) {
                if (this.productListing[i]['product_id'] == product.product_id) {
                  this.productListing[i]['back_in_stock'] = ''
                  this.productListing[i]['item_id'] = ''
                }
              }
            this.promotionApplyCount = data.response.in_cart_total_count
            this.promotionDetails.promotion_applied_count = data.response.promotion_applied_count ? data.response.promotion_applied_count : 0
            this.promotionDetails.is_promotion_applied = data.response.promotion_applied_count > 0 ? 1 : 0
            if(data.response.in_cart_total_count == 0){
              this.itemsPending = 0
              this.promotionProductListing()
           }else{
             this.itemsPending = this.promotionDetails?.promotion_apply_total_count - this.promotionApplyCount
             this.freeProductListing = []
             this.freeProductListing = data.response.free_product?.free_products
             this.calculateCostAndRSP()
           }
              this.statePersiste.emitminiCartData('update mini cart')
              this.alertService.success('Product removed.')
            }

          }

          }

      )

  }

  onChangePromotionCount(promotion,event,template: TemplateRef<any>,type){
    if(event == 0){
      this.promotionDetails['promotion_applied_count'] = 0
      this.bsModalRef = this.modalService.show(template,  Object.assign({}, {class: 'modal-dialog-centered custom-modal confirm' , backdrop:  'static' as 'static', keyboard: false, initialState : {rule_id : promotion.rule_id,removefullDeal:true,type:type}}));
    }
    else if(event < promotion.promotion_applied_count){
      let originalCount = this.promotionDetails.promotion_applied_count
      this.promotionDetails['promotion_applied_count'] = this.promotionDetails['promotion_applied_count'] - 1 
      this.removeDeal(promotion.rule_id,false,originalCount)
    }else{
      this.addDeal(promotion.rule_id)
    }
  }
  
  removeDeal(rule_id,removefullDeal,originalCount){
    let dataObj = { 'rule_id': rule_id ,removefull_deal : removefullDeal}
    this.bsModalRef?.hide()
    this.googleAnalyticsService.eventEmitter(SharedConsts.PROMOTION_REMOVE_DEAL_PROMOTION_DETAILS_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.PROMOTION_REMOVE_DEAL_PROMOTION_DETAILS_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
    this.homeService.removeDeal(dataObj).subscribe({
      next: (data) => {
        if (data.status == 1180) {
          localStorage.setItem('closeStorInfoMessage', data.response.msg)
          document.getElementById("openclosedStoreInfo").click();
        }
         if (data.status == 2212) {
          this.alertService.error(data.response)
          this.promotionProductListing()
        }
        else if (data.status == 1165) {
          this.toastService.error('Some of the products of the promotion are not available now.')
          this.promotionProductListing()
        }
        else if (data.status == 403 || data.status == 1151 || data.status == 1163) {
          this.toastService.error(data.response)
          this.promotionProductListing()
        }
        else {
            // this.promotionDetails.is_promotion_applied = 1
            // this.promotionDetails.promotion_applied_count = data.response.promotion_applied_count ? data.response.promotion_applied_count : 0 
            this.toastService.success('Deal Removed Successfully')
            this.statePersiste.emitminiCartData('update mini cart')
            this.promotionProductListing()
          }
        // }
      }, error: (err) => {
        this.toastService.error(err.error.message ? err.error.message : 'Something went wrong')
        this.promotionDetails = { ...this.promotionDetails , promotion_applied_count : originalCount }
      }
    })
  }

  onPromotionRemovalCancel(type){
    if(type == 'deletebtn'){
      this.promotionDetails = { ...this.promotionDetails , promotion_applied_count : this.promotionDetails.promotion_applied_count   }
    }else{
      this.promotionDetails = { ...this.promotionDetails , promotion_applied_count : 1   }
    }
    this.bsModalRef?.hide()
  }


  onPromotionRemove(promotionDetails,template: TemplateRef<any>,type){
    this.bsModalRef = this.modalService.show(template,  Object.assign({}, {class: 'modal-dialog-centered custom-modal confirm' , backdrop:  'static' as 'static', keyboard: false, initialState : {rule_id:promotionDetails.rule_id,removefullDeal:true,type:type}}));
  }

  calculateCostAndRSP(){
    this.totalCost = 0
    this.totalRSP = 0
    
    this.freeProductListing?.forEach(x =>{
      this.totalCost += x.price && x.qty ? parseFloat(x.price)*+x.qty : 0;
      this.totalRSP += x.rsp && x.qty && x.size_case ? (parseFloat(x.rsp)*(+x.size_case))*(+x.qty) : 0;
    })
    
    this.totalCost = this.totalCost.toFixed(2);
    this.totalRSP = this.totalRSP.toFixed(2);
  }

  getImagePath(sku) {
    return this.imagePath + sku + '.jpg'
  }
  onImageError(event: any): void {
    event.target.src = '../../../../assets/images/default-product.svg';
  } 

}
